import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateUserRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-user",
            component: () => loadView(import("./AssociateUserTable.vue")),
        },
    },
    create: {
        route: {
            path: "/associate-user/create",
            component: () => loadView(import("./AssociateUserCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/associate-user/update/:id",
            component: () => loadView(import("./AssociateUserUpdate.vue")),
        },
        build(id: string) {
            return `/associate-user/update/${id}`;
        },
    },
});
